import { Icon } from "@atoms";
import { faIcon } from "@utils/faIcon";
import { Component } from "react";
import WrapperButton from "../../core/buttons/WrapperButton";


class InlineGeneralOverrideDisplay extends Component {

    render() {
        const { item, requestAction } = this.props

        const discount = `${-parseFloat(item.price_adjustment_percent)}%`

        return (
            <WrapperButton key={`${item.id}_${item.price_adjustment_percent}`} type="object_link" handler={event => requestAction("ITEM_EDIT")} title={`Discount: ${discount}`} ariaLabel="Update Item">
                <div className="data-panel__list-select__option__label line-item-label">
                    <div className="line-item-label__row">
                        <div className="line-item-label__field" aria-label="Discount">
                            <div className="line-item-label__field-label" aria-hidden="true">Discount</div>
                            <div className="line-item-label__field-value">{discount}</div>
                        </div>
                    </div>
                </div>
                <div className="data-panel__list-select__option__icon"><Icon containerClassName="icon-inline" icon={faIcon({ name: "angle-right", style: "regular" })} /></div>
            </WrapperButton>
        )
    }
}

export default InlineGeneralOverrideDisplay;
